import { SearchFacetField } from './search-facet-field.model';
import { SearchFacetRangeQuery } from './search-facet-range-query.model';

export class SearchFacetOptions {
  fields: SearchFacetField[] = [];
  rangeQueries: SearchFacetRangeQuery[] = [];
  limit?: number;
  minCount?: number;

  public getRangeQuery(query: string): SearchFacetRangeQuery | null {
    const cleanedQuery = query.replace(/{[^}]+}/i, '').trim();
    for (const rangeQuery of this.rangeQueries) {
      if (rangeQuery.query === cleanedQuery) {
        return rangeQuery;
      }
    }
    return null;
  }
}
